import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { useHistory, useLocation, useParams } from "react-router";
import Button from "@mui/material/Button";
import I18N from "oc-modules/oc-I18N";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BoothDetails from "./popovers/BoothDetails";
import SaveIcon from "@mui/icons-material/Save";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import { Dialog, useMediaQuery } from "@material-ui/core";
import LogoSvg from "../styles/images/logo.svg";
import { SearchButton } from "./Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const styles = {
  toolbar: {
    justifyContent: "space-between",
    position: "relative",
  },
};

export default function () {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const [openBoothDetails, setOpenBoothDetails] = React.useState(false);
  const onConfiguratorPage = /\/(.*)\/(.*)\/configurator/.test(location.pathname);

  let navigationLink = "";
  switch (true) {
    case /\/(.*)\/booths/.test(location.pathname): {
      navigationLink = "/exhibitions";
      break;
    }
    case /\/(.*)\/(.*)\/configurator/.test(location.pathname): {
      navigationLink = `/${params.exhibitionId}/booths`;
      break;
    }
    case /\/(.*)\/configurator/.test(location.pathname): {
      navigationLink = `/booths/`;
      break;
    }
  }

  const navigation = () => {
    history.push(navigationLink);
    APP.arrangement.resetBoothCustomization();
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        color="white"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          boxShadow: "none",
          transition: "none",
          borderBottom: "2px solid #E2E2E2",
          paddingLeft: "15px",
          paddingRight: "18px",
          paddingTop: "6px",
          paddingBottom: "6px",
          [theme.breakpoints.up("lg")]: {
            paddingLeft: "6%",
            paddingRight: "6%",
            paddingTop: 0,
            paddingBottom: 0,
          },
        }}
      >
        <Toolbar
          sx={{
            ...styles.toolbar,
            justifyContent: navigationLink ? "space-between" : "flex-end",
            paddingLeft: "0 !important",
            paddingRight: "0 !important",
          }}
        >
          {!navigationLink && (
            <a
              href={I18N("LogoLink", { interpolation: { escapeValue: true } })}
              style={{ textDecoration: "none", marginRight: "auto" }}
            >
              <img
                src={APP.richMetadata.getLogo()}
                alt={"interplan Logo"}
                style={{
                  width: "100%",
                  maxWidth: "100px",
                  [theme.breakpoints.up("lg")]: {
                    maxWidth: "100%",
                  },
                }}
              />
            </a>
          )}
          {navigationLink && (
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                onClick={navigation}
                color="secondary"
                sx={{
                  fontSize: "16px",
                  mr: "0",
                  textTransform: "none",
                  minWidth: "auto",
                  [theme.breakpoints.up("lg")]: {
                    mr: "22px",
                  },
                  "&:hover": {
                    color: "#C91113",
                    backgroundColor: "#fff !important",
                    svg: {
                      stroke: "#C91113",
                    },
                  },
                }}
                variant="text"
                startIcon={<ChevronLeftIcon sx={{ fontSize: "24px !important" }} />}
              >
                <Typography
                  sx={{
                    display: "none",
                    [theme.breakpoints.up("lg")]: {
                      display: "block",
                    },
                  }}
                >
                  {I18N("Back")}
                </Typography>
              </Button>

              {navigationLink && location.pathname.includes("configurator") && (
                <Box
                  sx={{
                    display: "block",
                    [theme.breakpoints.up("lg")]: {
                      display: "none",
                    },
                  }}
                >
                  {onConfiguratorPage && (
                    <Button
                      color="secondary"
                      onClick={() => setOpenBoothDetails(true)}
                      variant="text"
                      sx={{
                        textTransform: "none",
                        minWidth: "auto",
                        "&:hover": {
                          backgroundColor: "#fff !important",
                          color: "#C91113",
                          svg: {
                            stroke: "#C91113",
                          },
                        },
                      }}
                      startIcon={<InfoOutlinedIcon sx={{ fontSize: "24px !important" }} />}
                    >
                      <Typography
                        sx={{
                          display: "none",
                          [theme.breakpoints.up("lg")]: {
                            display: "block",
                          },
                        }}
                      >
                        {I18N("BoothDetails")}
                      </Typography>
                    </Button>
                  )}
                </Box>
              )}
            </Box>
          )}

          <Box sx={{ display: "flex" }}>
            {navigationLink && location.pathname.includes("configurator") && (
              <Button
                color="secondary"
                onClick={APP.saveAction}
                variant="text"
                startIcon={<SaveIcon />}
                sx={{
                  mr: "6px",
                  textTransform: "none",
                  [theme.breakpoints.up("lg")]: {
                    mr: "22px",
                  },
                  "&:hover": {
                    backgroundColor: "#fff !important",
                    color: "#C91113",
                    svg: {
                      stroke: "#C91113",
                    },
                  },
                }}
              >
                {I18N("Save")}
              </Button>
            )}

            {location.pathname.includes("exhibitions") && <SearchButton />}

            <Button
              onClick={() => APP.changeLang()}
              color="secondary"
              sx={{
                mr: 0,
                textTransform: "none",
                [theme.breakpoints.up("lg")]: {
                  mr: "22px",
                },
                "&:hover": {
                  color: "#C91113",
                  backgroundColor: "#fff !important",
                  svg: {
                    stroke: "#C91113",
                  },
                },
              }}
              variant="text"
            >
              {I18N("OtherLang")}
            </Button>

            {!location.pathname.includes("configurator") && (
              <Button
                variant="contained"
                sx={{
                  borderRadius: 26,
                  ml: "18px",
                  textTransform: "none",
                  boxShadow: 0,
                  [theme.breakpoints.up("lg")]: {
                    ml: 0,
                  },
                }}
              >
                {I18N("Login")}
              </Button>
            )}

            {navigationLink && location.pathname.includes("configurator") && (
              <Box
                sx={{
                  display: "none",
                  [theme.breakpoints.up("lg")]: {
                    display: "block",
                  },
                }}
              >
                {onConfiguratorPage && (
                  <Button
                    color="secondary"
                    onClick={() => setOpenBoothDetails(true)}
                    variant="text"
                    sx={{
                      textTransform: "none",
                      "&:hover": {
                        color: "#C91113",
                        svg: {
                          stroke: "#C91113",
                        },
                      },
                    }}
                    startIcon={<InfoOutlinedIcon />}
                  >
                    <Box
                      sx={{
                        display: "none",
                        [theme.breakpoints.up("lg")]: {
                          display: "block",
                        },
                      }}
                    >
                      {I18N("BoothDetails")}
                    </Box>
                  </Button>
                )}
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          height: "70px",
          [theme.breakpoints.up("lg")]: {
            height: "64px",
          },
        }}
      />
      <Dialog
        open={openBoothDetails}
        className={"boothDetailsDialog"}
        fullScreen={fullScreen}
        onClose={() => setOpenBoothDetails(false)}
      >
        <BoothDetails setOpenBoothDetails={setOpenBoothDetails} />
      </Dialog>
    </>
  );
}
